class LTAReviewsCarousels extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.swiperCarouselEls = this.querySelectorAll('l-swiper-carousel')

		if (this.swiperCarouselEls.length < 2) return

		const firstSwiperCarousel = this.swiperCarouselEls[0]?.swiperCarousel
		const secondSwiperCarousel = this.swiperCarouselEls[1]?.swiperCarousel

		if (firstSwiperCarousel && secondSwiperCarousel) {
			firstSwiperCarousel.controller.control = secondSwiperCarousel
			secondSwiperCarousel.controller.control = firstSwiperCarousel
		}
	}
}

customElements.define('l-review-carousels', LTAReviewsCarousels)

